import {graphql} from "gatsby";
import * as React from "react";
import Layout from "../components/Layout/layout";
import Seo from "../components/SEO/SEO";
import Hero from "../components/Home/Hero/Hero";
import Products from "../components/Home/Products";
import OtherOpportunities from "../components/Home/OtherOpportunities";
import Cases from "../components/Home/Cases";
import Digits from "../components/Home/Digits/Digits";
import Clients from "../components/Home/Clients";
import Opportunities from "../components/Home/Opportunities";
import Cta from "../components/Home/CTA/Cta";
import WhyITSM from "../components/Home/WhyITSM";
import Solutions from "../components/Home/Solutions";
import Blog from "../components/Home/Blog";
import Faq from "../components/Home/Faq";
import Testimonials from "../components/Home/Testimonials/Testimonials";

const IndexPage = ({data: {strapiHomeNew}}) => {
    const {
        seo,
        hero,
        products,
        otherOpportunities,
        cases,
        digits,
        clients,
        opportunities,
        ctaBanners,
        whyITSM,
        solutions,
        articles,
        faq,
        testimonials,
    } = strapiHomeNew;

    return (
        <Layout>
            {seo && <Seo seo={seo} />}

            {hero && <Hero {...hero} />}
            {products && <Products {...products} />}
            {digits && <Digits {...digits} />}
            {clients && <Clients {...clients} />}
            {opportunities && <Opportunities {...opportunities} />}
            {otherOpportunities && <OtherOpportunities {...otherOpportunities} />}
            {ctaBanners && ctaBanners[0] && <Cta {...ctaBanners[0]} />}
            {whyITSM && <WhyITSM {...whyITSM} />}
            {solutions && <Solutions {...solutions} />}
            {cases && <Cases {...cases} />}
            {testimonials && <Testimonials {...testimonials} />}
            {articles && <Blog {...articles} />}
            {ctaBanners && ctaBanners[1] && <Cta {...ctaBanners[1]} />}
            {faq && <Faq {...faq} />}
        </Layout>
    );
};

export default IndexPage;

export const pageQuery = graphql`
    query {
        strapiHomeNew {
            articles {
                articles {
                    id
                    title
                    description
                    slug
                    readingTime
                    publishDate
                    tags: articleTags {
                        title
                        slug
                    }
                }
            }
            cases {
                items {
                    id
                    url
                    value
                    valueDescription
                    description
                    logo {
                        mime
                        width
                        height
                        localFile {
                            publicURL
                            childImageSharp {
                                gatsbyImageData
                            }
                        }
                    }
                }
            }
            clients {
                logos {
                    id
                    mime
                    width
                    height
                    localFile {
                        publicURL
                        childImageSharp {
                            gatsbyImageData
                        }
                    }
                }
            }
            ctaBanners {
                id
                title
                description
                buttonText
                buttonUrl
                image {
                    mime
                    width
                    height
                    localFile {
                        publicURL
                        childImageSharp {
                            gatsbyImageData
                        }
                    }
                }
            }
            digits {
                title
                digits {
                    id
                    value
                    description
                }
            }
            faq {
                items {
                    id
                    question
                    answer
                }
            }
            hero {
                title
                description
                variant
                buttonText
                buttonUrl
                image {
                    mime
                    width
                    height
                    localFile {
                        publicURL
                        childImageSharp {
                            gatsbyImageData
                        }
                    }
                }
            }
            opportunities {
                title
                opportunity {
                    id
                    title
                    description
                    functions {
                        id
                        title
                        description
                        url
                        image {
                            mime
                            width
                            height
                            localFile {
                                publicURL
                                childImageSharp {
                                    gatsbyImageData
                                }
                            }
                        }
                    }
                }
            }
            otherOpportunities {
                title
                description
                items {
                    id
                    title
                    url
                    image {
                        mime
                        width
                        height
                        localFile {
                            publicURL
                            childImageSharp {
                                gatsbyImageData
                            }
                        }
                    }
                }
            }
            products {
                title
                description
                products {
                    id
                    name
                    description
                    link
                    image {
                        mime
                        width
                        height
                        localFile {
                            publicURL
                            childImageSharp {
                                gatsbyImageData
                            }
                        }
                    }
                }
            }
            seo {
                title
                description
                openGraph {
                    title
                    description
                    image {
                        url
                    }
                }
            }
            solutions {
                items {
                    id
                    title
                    url
                    sortOrder
                    icon {
                        mime
                        width
                        height
                        localFile {
                            publicURL
                            childImageSharp {
                                gatsbyImageData
                            }
                        }
                    }
                }
            }
            testimonials {
                items {
                    id
                    author
                    authorPosition
                    content
                    description
                    url
                    authorPhoto {
                        mime
                        width
                        height
                        localFile {
                            publicURL
                            childImageSharp {
                                gatsbyImageData
                            }
                        }
                    }
                    logo {
                        mime
                        width
                        height
                        localFile {
                            publicURL
                            childImageSharp {
                                gatsbyImageData
                            }
                        }
                    }
                }
            }
            whyITSM {
                title
                description
                image {
                    mime
                    width
                    height
                    localFile {
                        publicURL
                        childImageSharp {
                            gatsbyImageData
                        }
                    }
                }
                items {
                    id
                    title
                    description
                    url
                    icon {
                        mime
                        width
                        height
                        localFile {
                            publicURL
                            childImageSharp {
                                gatsbyImageData
                            }
                        }
                    }
                }
            }
        }
    }
`;
